
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/BlogDetail",
      function () {
        return require("private-next-pages/BlogDetail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/BlogDetail"])
      });
    }
  